/* eslint-disable max-len */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/prop-types */
/* eslint-disable react/destructuring-assignment */
import React, { useContext } from 'react';
import { QueryProvider, QueryContext } from '@thd-nucleus/data-sources';

const ssr = typeof window === 'undefined';

let SeoGeneratedContentImport;
let SeoLinksImport;

/** *********************
 * Seo Generated Content
 ********************** */
export const SeoGeneratedContentLoad = () => import(
  /* webpackChunkName: "seo-generated-content" */
  '@thd-olt-component-react/seo-generated-content')
  .then((module) => {
    const { SeoGeneratedContent } = module;

    SeoGeneratedContentImport = (props) => {
      const value = useContext(QueryContext);
      return (
        <QueryProvider defaultVariables={value.defaultVariables.current}>
          <SeoGeneratedContent {...props} />
        </QueryProvider>
      );
    };
  });

export const SeoGeneratedContent = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/seo-generated-content')).SeoGeneratedContent
  : (props) => <SeoGeneratedContentImport {...props} />;

export const SeoGeneratedContentModel = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/seo-generated-content')).SeoGeneratedContent.dataModel
  : {};

/** *********************
 * Seo Links
 ********************** */
export const SeoLinksLoad = () => import(
  /* webpackChunkName: "seo-links" */
  '@thd-olt-component-react/seo-links')
  .then((module) => {
    const { SeoLinks } = module;

    SeoLinksImport = (props) => {
      const value = useContext(QueryContext);
      return (
        <QueryProvider defaultVariables={value.defaultVariables.current}>
          <SeoLinks {...props} />
        </QueryProvider>
      );
    };
  });

export const SeoLinks = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/seo-links')).SeoLinks
  : (props) => <SeoLinksImport {...props} />;

export const SeoLinksModel = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/seo-links')).SeoLinks.dataModel
  : {};

export const productPageImport = () => {
  return import(
    /* webpackChunkName: "product" */
    '../../pages/product/ProductContainer'
  );
};